import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MessageServiceService {


  idCookie: any = null;

  constructor(
    private router: Router
  ) { }

  sendHeighMessage(height: number) {
    if (window.top) {
      window.top.postMessage({ type: "iFrameTipiVisiteHeightChange", height: height }, '*');
    }
  }

  sendHeighMessageRecensioni(height: number) {
    if (window.top) {
      window.top.postMessage({ type: "iFrameRecensioniHeightChange", height: height }, '*');
    }
  }

  sendHeighMessageFaq(height: number) {
    if (window.top) {
      window.top.postMessage({ type: "iFrameFaqHeightChange", height: height }, '*');
    }
  }

  sendHeighMessageCollegate(height: number) {
    if (window.top) {
      window.top.postMessage({ type: "iFrameCollegateHeightChange", height: height }, '*');
    }
  }

  sendClickMessage(codiceForm: string, idTipoVisita: number, lingua: string, step: number, idCookie: any) {
    if (window.top) {
      window.top.postMessage({ type: "iFrameTipiVisiteClick", infotipo: { codiceForm, idTipoVisita, lingua, step, idCookie } }, '*');
    }
  }

  sendHeighMessageVini(height: number) {
    if (window.top) {
      let url = this.router.url;
      if (url.includes('null')) {
        url = url.replace("null", this.getIdCookie());
      }
      window.top.postMessage({ type: "iFrameViniHeightChange", height: height }, '*');
      window.top.postMessage({ type: "setUrl", infotipo: { url: url } }, '*');
    }
  }
  sendClickMessageVini(codiceForm: string, idVino: number, lingua: string, step: number, idCookie: any) {
    if (window.top) {
      window.top.postMessage({ type: "iFrameViniClick", infotipo: { codiceForm, idVino, lingua, step, idCookie } }, '*');
    }
  }

  chiudiBooking() {
    if (window.top) {
      window.top.postMessage({ type: "chiudiBooking", infotipo: {} }, '*');
    }
  }

  apriBooking() {
    const idCookie = this.getIdCookie();
    if (window.top) {
      window.top.postMessage({ type: "apriBooking", infotipo: { idCookie } }, '*');
    }
  }

  sendIdCookie(idCookie: any) {
    if (window.top) {
      window.top.postMessage({ type: "sendIdCookie", infotipo: { idCookie } }, '*');
    }
  }

  setIdCookie(id) {
    this.idCookie = id;
  }

  getIdCookie() {
    return this.idCookie;
  }

}
